import React from 'react';
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { Alert, Box, Typography } from '@mui/material';

const style={
    formTitle:{
      fontWeight:'bold !important' 
    },
    formDescription:{
      color:'#9b9b9b'
    },
    formContainer:{
      padding: '1rem !important',
      border: '3px solid #748DA6',
      borderRadius: '10px',
      backgroundColor: '#f1f7ff59',
      height:'fit-content'
    },
    gridBox:{
      display:'grid',
      gridTemplateColumns:'40% 40%',
      columnGap:'5%',
      rowGap:'3%',
      justifyContent:'space-around',
      marginTop:'2rem'
    },
    mobileGridBox:{
      display:'grid',
      gridTemplateColumns:'90%',
      // columnGap:'5%',
      rowGap:'3%',
      justifyContent:'center',
      marginTop:'2rem'
    },
    modalStyle :{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
    },
    txtField:{
      width:'100%', 
    },
    headerContainer:{
      display:'flex',
      width:'100%',
      justifyContent:'center'
    },
    stateHandler:{
      display:'flex',
    },
    stateType:{
      fontWeight:'bold'
    }
  }
function DescriptionModal() {

    const cacheRtl = createCache({
        key: "muirtl",
        stylisPlugins: [prefixer, rtlPlugin]
    });
  return (
    <CacheProvider value={cacheRtl}>
        <div>
            <Box sx={style.headerContainer}>
                <Alert severity="error" sx={{width:'100%',display:'flex',justifyContent:'center'}}>
                    <Typography variant="body1" sx={style.formTitle} >قابل توجه بازرگانان محترم</Typography>
                </Alert>
            </Box>
            <Box>
                <Typography variant="body1" color="initial" sx={{padding:'0.5rem',fontWeight:'bold'}}>
                با سلام و احترام    
                </Typography>
                <Typography variant="body1" color="initial" sx={{padding:'0.5rem', textAlign:'justify'}}>
                    لطفا پس از تکمیل فرم های پیوست، اصل مدارک به صورت فیزیکی به آدرس شرکت ارسال گردد. تا حواله شما در موعد مقرر انجام گردد. بدیهی است در صورت عدم ارسال نسخه فیزیکی مسئولیت عدم انجام حواله با آن شرکت خواهد بود.
                </Typography>
                <Alert severity="warning">
                    <Typography variant="body1" color="initial" sx={{padding:'0.5rem', textAlign:'justify'}}>
                    <span style={{fontWeight:'bold'}}>استثناء:</span> شرکت های محترمی که در شهرستان فعالیت دارند می توانند فایل مدارک را به کارشناس حواله ایمیل نمایند و سپس نسخه فیزیکی مدارک را ارسال فرمایند.
                    </Typography>
                </Alert>
                <Typography variant="body1" color="initial" sx={{padding:'0.5rem'}}>
                    همچنین بایستی فایل مدارک زیر برای کارشناس حواله مربوطه بر روی واتساپ یا ایمیل ارسال گردد.
                </Typography>

                    <ul className='modalULFirst'>
                        <li >
                            ثبت سفارش + گواهی ثبت آماری (تخصیص ارز)
                        </li>
                        <li>
                            فایل پی دی اف پروفرما با کیفیت بالا و دارای مهر رنگی
                        </li>
                        <li>
                            آخرین روزنامه رسمی دارای صاحبین امضاء
                        </li>
                        <li>
                            در صورت درخواست تحویل cash ، فایل با کیفیت و رنگی آی دی کارت
                        </li>
                    </ul>
                <Typography variant="body1" color="initial" sx={{padding:'0.5rem',textDecoration:'underline',fontWeight:'bold'}}>
                    نکات مهم:
                </Typography>
                <ul className='modalUL'>
                    <li style={{textAlign:'justify'}}>
             تمامی فرم ها بایستی به صورت تایپ شده برای کارشناس حواله ارسال گردد.
                    </li>
                    
                    <li style={{textAlign:'justify'}}>
                        در صورت وجود هر گونه توضیح، بایستی در بند توضیحات فرم درخواست صدور حواله ارزی ذکر گردد
                    </li>
                    <li style={{textAlign:'justify'}}>
                       معرفی نامه بایستی به نام کارشناس پرونده (که مدارک را تکمیل و ارسال مینماید و رسید پرداختی به ایشان تحویل می شود ) تکمیل گردد
                    </li>
                    <li style={{textAlign:'justify'}}>
                        در خصوص حواله های یوانی (شخص یا شرکت) بایستی نام ذینفع و نام بانک مربوطه به زبان چینی در فرم دستور پرداخت درج گردیده و یا به صورت text نیز برای کارشناس حواله ارسال گردد
                    </li>
                </ul>
            </Box>
        </div>
    </CacheProvider>
  )
}

export default DescriptionModal